import axiosAuth from "utils/request";
//---------------------------- List ----------------------------//

export async function getAssetDisposalListByAssetNo(limit, page, Id, No) {
  const uriQueryString = {
    Limit: limit,
    Page: page,
    WhereGroupList: [
      {
        ConditionList: [
          {
            AndOr: "And",
            Field: "AstId",
            Operator: "=",
            Value: Id,
          },
          {
            AndOr: "And",
            Field: "AstNo",
            Operator: "=",
            Value: No,
          },
        ],
      },
    ],
    Exclude: ["AstPhoto"],
  };
  const { data } = await axiosAuth.post(
    "/api/assetDisposal/search",
    uriQueryString,
  );
  return data;
}

export async function getAstCategory() {
  const { data } = await axiosAuth.get("/api/astCategory");
  return data;
}

export async function getAstDepartment() {
  const { data } = await axiosAuth.get("/api/assetDepartment");
  return data;
}

export async function getAstLocation() {
  const { data } = await axiosAuth.get("/api/assetLocation");
  return data;
}
//---------------------------- Search ----------------------------//

export async function getPreAssetSearchList(uriQueryString) {
  const { data } = await axiosAuth.post("/api/preasset/search", uriQueryString);
  return data;
}

export async function getAssetRegisterSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/assetRegister/search",
    uriQueryString,
  );
  return data;
}

export async function getAssetDisposalSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/assetDisposal/search",
    uriQueryString,
  );
  return data;
}

export async function getAstCategorySearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/astCategory/search",
    uriQueryString,
  );
  return data;
}

export async function getAstDepartmentSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/assetDepartment/search",
    uriQueryString,
  );
  return data;
}

export async function getAstLocationSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/assetLocation/search",
    uriQueryString,
  );
  return data;
}

//---------------------------- Detail ----------------------------//

export async function getAstCategoryDetail(Id) {
  const { data } = await axiosAuth.get(`/api/astCategory/${Id}`);
  return data;
}

export async function createAstCategoryDetail(param) {
  const { data } = await axiosAuth.post("/api/astCategory", param);
  return data;
}

export async function updateAstCategoryDetail(param) {
  const { data } = await axiosAuth.put(`/api/astCategory/${param.Id}`, param);
  return data;
}

export async function delAstCategoryDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/astCategory/${Id}`);
  return data;
}

export async function getAstDepartmentDetail(Id) {
  const { data } = await axiosAuth.get(`/api/assetDepartment/${Id}`);
  return data;
}

export async function createAstDepartmentDetail(param) {
  const { data } = await axiosAuth.post("/api/assetDepartment", param);
  return data;
}

export async function updateAstDepartmentDetail(param) {
  const { data } = await axiosAuth.put(
    `/api/assetDepartment/${param.Id}`,
    param,
  );
  return data;
}

export async function delAstDepartmentDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/assetDepartment/${Id}`);
  return data;
}

export async function getAstLocationDetail(Id) {
  const { data } = await axiosAuth.get(`/api/assetLocation/${Id}`);
  return data;
}

export async function createAstLocationDetail(param) {
  const { data } = await axiosAuth.post("/api/assetLocation", param);
  return data;
}

export async function updateAstLocationDetail(param) {
  const { data } = await axiosAuth.put(`/api/assetLocation/${param.Id}`, param);
  return data;
}

export async function delAstLocationDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/assetLocation/${Id}`);
  return data;
}

export async function getPreAssetDetail(PastSeq) {
  const { data } = await axiosAuth.get(`/api/preasset/${PastSeq}`);
  return data;
}

export async function delPreAssetDetail(id) {
  const { data } = await axiosAuth.delete(`/api/preasset/${id}`);
  return data;
}

export async function undoPreAssetDetail(id) {
  const { data } = await axiosAuth.put(`/api/preasset/${id}`);
  return data;
}

export async function getAssetRegDetail(RegId) {
  const { data } = await axiosAuth.get(`/api/assetRegister/${RegId}`);
  return data;
}

export async function createAssetRegDetail(param) {
  const { data } = await axiosAuth.post("/api/assetRegister", param);
  return data;
}

export async function updateAssetRegDetail(param) {
  const { data } = await axiosAuth.put(
    `/api/assetRegister/${param.RegId}`,
    param,
  );
  return data;
}

export async function delAssetRegDetail(RegId) {
  const { data } = await axiosAuth.delete(`/api/assetRegister/${RegId}`);
  return data;
}

export async function getAssetDisDetail(DisposalId) {
  const { data } = await axiosAuth.get(`/api/assetDisposal/${DisposalId}`);
  return data;
}

export async function createAssetDisDetail(param) {
  const { data } = await axiosAuth.post("/api/assetDisposal", param);
  return data;
}

export async function updateAssetDisDetail(param) {
  const { data } = await axiosAuth.put(
    `/api/assetDisposal/${param.DisposalId}`,
    param,
  );
  return data;
}

export async function delAssetDisDetail(DisposalId) {
  const { data } = await axiosAuth.delete(`/api/assetDisposal/${DisposalId}`);
  return data;
}

//---------------------------- History ----------------------------//

export async function getAssetHisByAssetNo(astId, astNo) {
  const { data } = await axiosAuth.get(
    `/api/assetHistory?astId=${encodeURIComponent(astId)}&astNo=${astNo}`,
  );
  return data;
}

export async function getAssetHisLocationByAssetNo(astId, astNo) {
  const { data } = await axiosAuth.get(
    `/api/assetHistory/LocLog?astId=${encodeURIComponent(astId)}&astNo=${astNo}`,
  );
  return data;
}

//---------------------------- GetNetAmount & GetAvailable (Disposal) ----------------------------//

export async function getAssetDisposalAccuDepre(param) {
  const { data } = await axiosAuth.post("/api/assetDisposalAccuDepre", param);
  return data;
}

export async function checkRegisterDisposal(id) {
  const { data } = await axiosAuth.get(`/api/assetRegister/isDisposal/${id}`);
  return data;
}

export async function copyAssetRegister(param) {
  const { data } = await axiosAuth.post("/api/assetRegister/copy", param);
  return data;
}

export async function changeLocation(param) {
  const { data } = await axiosAuth.put(
    "/api/assetRegister/changeLocation",
    param,
  );
  return data;
}

export async function getCountingDocumentAssetChangeLog(astId, astNo) {
  return {
    Data: [
      {
        AssetId: astId,
        AssetNo: astNo,
        ActionDate: "2026-06-25 14:30:22",
        CreatedBy: "Jane Smith",
        Action: "Location Update",
        OldValue: "Warehouse A",
        NewValue: "Warehouse C",
      },
      {
        AssetId: astId,
        AssetNo: astNo,
        ActionDate: "2026-06-25 14:32:05",
        CreatedBy: "Jane Smith",
        Action: "Serial No Update",
        OldValue: "S/N: 987654321",
        NewValue: "S/N: 123456789",
      },
    ],
  };
}

export async function getCountingDocumentSearchList(uriQueryString) {
  return {
    Data: [
      {
        DocNo: "CD25060001",
        Location: "Warehouse C",
        CountDate: "2026-06-25T00:00:00Z",
        Status: "Draft",
        CreatedByName: "Jane Smith",
        CreatedByEmail: "jane.smith@carmen.software",
        AuditLogs:
          "Created by Jane Smith at 2026-06-25 09:00\nSynced offline draft from Mobile App at 2026-06-25 14:30",
      },
      {
        DocNo: "CD25060002",
        Location: "Main Office",
        CountDate: "2026-06-26T00:00:00Z",
        Status: "Committed",
        CommitDate: "2026-06-26T17:45:00Z",
        CreatedByName: "John Doe",
        CreatedByEmail: "john.doe@carmen.software",
        AuditLogs:
          "Created by John Doe at 2026-06-26 08:30\nCommitted by John Doe at 2026-06-26 17:45",
      },
      {
        DocNo: "CD25060003",
        Location: "Warehouse A",
        CountDate: "2026-06-27T00:00:00Z",
        Status: "Void",
        CreatedByName: "Bob Wilson",
        CreatedByEmail: "bob.wilson@carmen.software",
        AuditLogs:
          "Created by Bob Wilson at 2026-06-27 10:00\nVoided by Bob Wilson at 2026-06-27 11:30",
      },
    ],
    Paging: {
      TotalRecord: 3,
      Page: 1,
      Limit: 10,
    },
  };
}

export async function getCountingDocumentDetail(docNo) {
  return {
    DocNo: docNo,
    Location:
      docNo === "CD25060002"
        ? "Main Office"
        : docNo === "CD25060003"
          ? "Warehouse A"
          : "Warehouse C",
    CountDate:
      docNo === "CD25060002"
        ? "2026-06-26T00:00:00Z"
        : docNo === "CD25060003"
          ? "2026-06-27T00:00:00Z"
          : "2026-06-25T00:00:00Z",
    Status:
      docNo === "CD25060002"
        ? "Committed"
        : docNo === "CD25060003"
          ? "Void"
          : "Draft",
    CommitDate: docNo === "CD25060002" ? "2026-06-26T17:45:00Z" : null,
    CreatedByName:
      docNo === "CD25060002"
        ? "John Doe"
        : docNo === "CD25060003"
          ? "Bob Wilson"
          : "Jane Smith",
    CreatedByEmail:
      docNo === "CD25060002"
        ? "john.doe@carmen.software"
        : docNo === "CD25060003"
          ? "bob.wilson@carmen.software"
          : "jane.smith@carmen.software",
    AuditLogs:
      docNo === "CD25060002"
        ? "Created by John Doe at 2026-06-26 08:30\nCommitted by John Doe at 2026-06-26 17:45"
        : docNo === "CD25060003"
          ? "Created by Bob Wilson at 2026-06-27 10:00\nVoided by Bob Wilson at 2026-06-27 11:30"
          : "Created by Jane Smith at 2026-06-25 09:00\nSynced offline draft from Mobile App at 2026-06-25 14:30",
    asset_counts: [
      {
        id: 1,
        doc_no: docNo,
        asset_id: "AST-0001",
        asset_name: 'MacBook Pro 16"',
        remaining_qty: 5,
        counted_qty: 5,
        incident_qty: 0,
        incident_type_code: "",
        incident_reason: "",
        incident_status: "",
        scanned_photo_url:
          "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=80",
        remark: "Counted OK, QR Scan",
        scan_method: "QR",
      },
      {
        id: 2,
        doc_no: docNo,
        asset_id: "AST-0002",
        asset_name: 'Dell UltraSharp 27" Monitor',
        remaining_qty: 10,
        counted_qty: 8,
        incident_qty: -2,
        incident_type_code: "MISSING",
        incident_reason: "Lost during office relocation to Building B",
        incident_status: "DONE",
        scanned_photo_url: "",
        remark: "2 units missing, confirmed with IT Manager",
        scan_method: "Manual",
      },
      {
        id: 3,
        doc_no: docNo,
        asset_id: "AST-0003",
        asset_name: "Cisco Catalyst Switch 9300",
        remaining_qty: 2,
        counted_qty: 2,
        incident_qty: 0,
        incident_type_code: "",
        incident_reason: "",
        incident_status: "",
        scanned_photo_url:
          "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=800&q=80",
        remark: "Mounted in main rack, scanned via RFID tag",
        scan_method: "RFID",
      },
      {
        id: 4,
        doc_no: docNo,
        asset_id: "AST-0004",
        asset_name: "Ergonomic Office Chair - Model X",
        remaining_qty: 15,
        counted_qty: 16,
        incident_qty: 1,
        incident_type_code: "SURPLUS",
        incident_reason: "Transferred from Floor 3 without update",
        incident_status: "PENDING",
        scanned_photo_url:
          "https://images.unsplash.com/photo-1505797149-43b0069ec26b?auto=format&fit=crop&w=800&q=80",
        remark: "One extra chair found in conference room C",
        scan_method: "Barcode",
      },
    ],
  };
}

export async function voidCountingDocument(docNo) {
  return {
    Success: true,
    Message: "Document successfully voided (Mock)",
  };
}

export async function getAssetCountsSearchList(uriQueryString) {
  return {
    Data: [],
    Paging: {
      TotalRecord: 0,
      Page: 1,
      Limit: 10,
    },
  };
}
